import { action, computed, observable } from 'mobx';

import { Breakpoints } from '@estee/elc-base-theme';
import { ViewController } from '@estee/elc-service';

import { AccountPageLoadedUseCase } from '~use-cases/AccountPageLoadedUseCase';

class AccountDashboardController extends ViewController {
    @observable public isMobileDevice: boolean;

    constructor() {
        super();
        this.setUserDevice = this.setUserDevice.bind(this);
    }

    public loaded = async () => {
        this.isLoading = true;
        await new AccountPageLoadedUseCase().execute();
        this.isLoading = false;
        this.setUserDevice();
        window.addEventListener('resize', this.setUserDevice);
    };

    @action private setUserDevice() {
        this.isMobileDevice = window.innerWidth < Breakpoints.desktop;
    }

    public unMounted = () => {
        window.removeEventListener('resize', this.setUserDevice);
    };

    @computed public get data() {
        return {
            isMobileDevice: this.isMobileDevice,
            isLoading: this.isLoading
        };
    }
}

export default AccountDashboardController;
